<template>
    <div class="col-lg-6  mb-3" :class="{'chart-loading': loading}">
        <h3 class="mb-3"><b>Kết Quả Thực Hiện Dự Án Theo Từng Nhóm Rủi Ro</b></h3>
        <div class="dashboard-box mb-3">
            <div>
                Đã hoàn thành <span class="success">{{ result.success }}</span><span class="total">/{{ result.total }}</span> dự án
            </div>
        </div>
        <Chart type="bar" :data="projectData" :options="projectOptions" :key="componentKey"/>
    </div>
</template>

<script>
import Chart from '@/components/Chart.vue';
export default {
    name: "chartProject",
    props: {
        project: Object,
        loading: Boolean
    },
    components: {
        Chart
    },
    watch: {
        "$props.project"() {
            this.result.success = this.project?.countSuccess ?? 0;
            this.result.total = this.project?.countAll ?? 0;
            this.projectData.labels = this.project?.dataChart?.label ?? [];
            this.projectData.datasets[0].data = this.project?.dataChart?.all ?? [];
            this.projectData.datasets[1].data = this.project?.dataChart?.success ?? [];
            this.componentKey++;
        }
    },
    data() {
        return {
            componentKey: 0,
            result: {
                success: 0,
                total: 0
            },
            projectData: {
                // labels: ['Cao', 'Thấp', 'Trung bình', 'Dự án năm 2024'],
                datasets: [
                    {
                        label: 'Kế hoạch',
                        barPercentage: 0.5,
                        backgroundColor: '#146082',
                        pointStyle: 'rect',
                        maxBarThickness: 32,
                        // data: [12, 2, 1, 14]
                    },
                    {
                        label: 'Thực hiện',
                        barPercentage: 0.5,
                        backgroundColor: '#E97131',
                        pointStyle: 'rect',
                        maxBarThickness: 32,
                        // data: [10, 2, 0, 10]
                    }
                ]
            },
            projectOptions: {
                plugins: {
                    legend: {
                        labels: {
                            usePointStyle: true,
                            color: '#495057'
                        },
                        position: 'bottom'
                    },
                    datalabels: {
                        color: '#000000',
                        anchor: 'end',
                        align: 'end',
                        clamp: true,
                        formatter: function(value) {
                            return String(value).replace(/(.)(?=(\d{3})+$)/g, "$1,");
                        }
                    }
                }
            }
        }
    }
}
</script>